var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperienceBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_450_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.625 44H1.375C0.61545 44 0 43.3845 0 42.625V9.625C0 8.86545 0.61545 8.25 1.375 8.25H42.625C43.3845 8.25 44 8.86545 44 9.625V42.625C44 43.3845 43.3845 44 42.625 44ZM2.75 41.25H41.25V11H2.75V41.25Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.125 24.75H6.875C3.0844 24.75 0 21.6656 0 17.875V9.625C0 8.86545 0.61545 8.25 1.375 8.25H42.625C43.3845 8.25 44 8.86545 44 9.625V17.875C44 21.6656 40.9156 24.75 37.125 24.75ZM2.75 11V17.875C2.75 20.1493 4.60075 22 6.875 22H37.125C39.3998 22 41.25 20.1493 41.25 17.875V11H2.75Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 9.625H31.625V4.125C31.625 3.36655 31.0084 2.75 30.25 2.75H13.75C12.9915 2.75 12.375 3.36655 12.375 4.125V9.625H9.625V4.125C9.625 1.85075 11.4758 0 13.75 0H30.25C32.5248 0 34.375 1.85075 34.375 4.125V9.625Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 30.25C19.7252 30.25 17.875 28.3998 17.875 26.125V20.625C17.875 18.3502 19.7252 16.5 22 16.5C24.2748 16.5 26.125 18.3502 26.125 20.625V26.125C26.125 28.3998 24.2748 30.25 22 30.25ZM22 19.25C21.2421 19.25 20.625 19.8671 20.625 20.625V26.125C20.625 26.8829 21.2421 27.5 22 27.5C22.7579 27.5 23.375 26.8829 23.375 26.125V20.625C23.375 19.8671 22.7579 19.25 22 19.25Z",
    fill: "#105099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 22H19.25V24.75H24.75V22Z",
    fill: "#105099"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceBlue);
export default __webpack_public_path__ + "static/media/experience-blue.d80511e9f4f62b4e25c3fcc80f243ead.svg";
export { ForwardRef as ReactComponent };